var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.0007 11.1673H48.0007V8.50065C48.0007 7.02598 46.8087 5.83398 45.334 5.83398H18.6673C17.1927 5.83398 16.0007 7.02598 16.0007 8.50065V11.1673H8.00065C6.52598 11.1673 5.33398 12.3593 5.33398 13.834V21.834C5.33398 33.3273 10.1313 40.2607 18.1847 40.5327C20.5313 44.5567 24.574 47.458 29.334 48.2607V53.834H24.0007V59.1673H40.0007V53.834H34.6673V48.2607C39.4247 47.4553 43.47 44.554 45.8167 40.5327C53.87 40.2607 58.6673 33.3273 58.6673 21.834V13.834C58.6673 12.3593 57.4753 11.1673 56.0007 11.1673ZM10.6673 21.834V16.5007H16.0007V32.5567V34.714C11.2433 32.7087 10.6673 25.298 10.6673 21.834ZM32.0007 43.1673C26.118 43.1673 21.334 38.3833 21.334 32.5007V11.1673H42.6673V32.5007C42.6673 38.3833 37.8833 43.1673 32.0007 43.1673ZM48.0007 34.714V32.5567V16.5007H53.334V21.834C53.334 25.298 52.758 32.7087 48.0007 34.714Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTrophy);
export default __webpack_public_path__ + "static/media/bx-trophy.aa89be2a5480c89a57bb2206700c92b8.svg";
export { ForwardRef as ReactComponent };